import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "./cx.js";

/** A white surface with a hairline edge and the one allowed shadow. Hierarchy comes from the title, not nested boxes. */
export function Card({
  title,
  actions,
  padded = true,
  className,
  children,
  ...rest
}: {
  title?: ReactNode;
  actions?: ReactNode;
  padded?: boolean;
  className?: string;
  children: ReactNode;
} & Omit<HTMLAttributes<HTMLElement>, "title" | "className" | "children">) {
  return (
    <section
      className={cx("overflow-hidden rounded-lg border border-line bg-surface shadow-card", className)}
      {...rest}
    >
      {title || actions ? (
        <header className="flex items-center justify-between gap-3 px-4 pt-4">
          {title ? <h2 className="m-0 text-base font-semibold text-ink">{title}</h2> : <span />}
          {actions}
        </header>
      ) : null}
      <div className={padded ? "p-4" : ""}>{children}</div>
    </section>
  );
}

/** The page body: gutter 24, section gap 24, one <main> per page (the skip link lands here). */
export function Page({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <main className={cx("flex min-w-0 flex-1 flex-col gap-6 bg-page px-6 py-6", className)}>{children}</main>
  );
}
